import type { Input } from "@/workflow_api/types/workflow";
import type { TimeValuesConfig } from "../types";

export const isValidField = (
  value: string | number | boolean | null | undefined,
): boolean => {
  return value !== null && value !== undefined;
};

export const getSerializedTimerInputs = (
  sourceInputs: Input,
  internalData?: TimeValuesConfig,
  externalData?: TimeValuesConfig,
) => {
  // Define timer config names for filtering
  const timerConfigNames: string[] = [
    "internal_max_unit",
    "internal_max_amount",
    "internal_max_preventions",
    "external_max_unit",
    "external_max_amount",
    "external_max_preventions",
    "consume_global_preventions",
  ];

  // Start by filtering out configurations that should be removed
  const inputs: Input = sourceInputs.filter((input) => {
    return !timerConfigNames.includes(input.name);
  });

  if (!internalData && !externalData) {
    return inputs;
  }

  // Define complete internal and external sets
  const configSets: Array<{
    name: string;
    value: string | boolean | number | null;
    type: string;
  }> = [];

  // Add internal configs if available - as a complete set
  if (internalData) {
    configSets.push(
      {
        name: "internal_max_unit",
        value: internalData.limit_unit,
        type: "STRING",
      },
      {
        name: "internal_max_amount",
        value: internalData.limit_amount,
        type: "INTEGER",
      },
      {
        name: "internal_max_preventions",
        value: internalData.limit_preventions ?? null,
        type: "INTEGER",
      },
    );
  }

  // Add external configs if available - as a complete set
  if (externalData) {
    configSets.push(
      {
        name: "external_max_unit",
        value: externalData.limit_unit,
        type: "STRING",
      },
      {
        name: "external_max_amount",
        value: externalData.limit_amount,
        type: "INTEGER",
      },
      {
        name: "external_max_preventions",
        value: externalData.limit_preventions ?? null,
        type: "INTEGER",
      },
      {
        name: "consume_global_preventions",
        value: externalData.global_preventions ?? false,
        type: "BOOLEAN",
      },
    );
  }
  return inputs.concat(configSets);
};
